// import { start, stop } from '../../../lib/blockEvent';

const state = {
  csrfToken: null,
  jwt: null,
  error: {},
  isBusy: false,
  isPanel: false,
  alertDialogState: {
    isOpenDialog: false,
    title: null,
    message: null,
    ok_btn: null,
    cancel_btn: null,
    closeDialogAction: null
  }
};

// getters
const getters = {};

// actions
const actions = {
  async openAlertDialog(context, params) {
    context.commit("openAlertDialog", params);
  },
  async closeAlertDialog(context, param) {
    var closeDialogAction = context.state.alertDialogState.closeDialogAction;
    /*await*/ closeDialogAction(param);
    context.commit("closeAlertDialog");
  }
};

// mutations
const mutations = {
  setError(state, value) {
    state.error = value;
  },
  csrfToken(state, token) {
    state.csrfToken = token;
  },
  setIsBusy(state, payload) {
    state.isBusy = payload;

    // イベント抑制するにはコメントアウト
    // payload ? start() : stop();
  },
  setIsPanel(state, payload) {
    state.isPanel = payload;
  },
  openAlertDialog(state, alertDialogState) {
    state.alertDialogState = Object.assign({}, alertDialogState, {
      isOpenDialog: true
    });
  },
  closeAlertDialog(state) {
    state.alertDialogState.isOpenDialog = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
